module.exports = "<label class=\"{{^Model.Enabled}} disabled {{/Model.Enabled}}\">\r\n    <input type=\"checkbox\" class=\"js-category-option-box \" data-category-name=\"{{Model.Name}}\" data-category-count=\"{{Model.Count}}\" checked />\r\n    <span title=\"{{Model.Name}}\" class=\"js-category-label\">{{Model.Label}}</span>\r\n</label>"


//////////////////
// WEBPACK FOOTER
// ./src/search/views/category-filter.html
// module id = 406
// module chunks = 1